import type { FC } from 'react';

import { MasonryGallerySingle, type MasonryGalleryImage } from '@/components/Work/Masonry';

interface HeroGallerySectionProps {
  media: MasonryGalleryImage;
}

const HeroGallerySection: FC<HeroGallerySectionProps> = ({ media }) => (
  <section className="w-full px-6 pb-2 sm:px-10 lg:px-16">
    <div className="mx-auto max-w-[96rem]">
      <MasonryGallerySingle images={[media]} />
    </div>
  </section>
);

export default HeroGallerySection;
